import { render, staticRenderFns } from "./diary_detail.vue?vue&type=template&id=13b5cce1&scoped=true&"
import script from "./diary_detail.vue?vue&type=script&lang=js&"
export * from "./diary_detail.vue?vue&type=script&lang=js&"
import style0 from "./diary_detail.vue?vue&type=style&index=0&id=13b5cce1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5cce1",
  null
  
)

export default component.exports